<template>
  <div class="time-sheet">
    <CCard class="filter">
      <CRow>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2">
            <CCol col="12">
              <label>{{ $t("timeSheets.start_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.start_date"
                @emitDate="startDate"
                v-model="searchData.start_date"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2">
            <CCol col="12">
              <label>{{ $t("timeSheets.end_date") }}</label>
            </CCol>
            <CCol col="12">
              <DatePickerFormFlex
                :propsDate="searchData.end_date"
                @emitDate="endDate"
                v-model="searchData.end_date"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol col="12">
              <label>{{ $t("label.member_companies") }}</label>
            </CCol>
            <CCol col="12">
              <select
                class="form-control form-group"
                v-model="searchData.company_code"
                @change="search"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option
                  v-for="(company, index) in companies"
                  :key="index"
                  :value="index"
                >
                  {{ company.name }}
                </option>
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>{{ $t("timeSheets.id_name") }}</label>
            </CCol>
            <CCol sm="12">
              <CInput
                type="text"
                v-model="searchData.employee_info"
                v-on:keyup.enter="search"
              />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>Foot</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.foot_code"
                @change="search"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option v-for="foot in foots" :key="foot.id" :value="foot.code">
                  {{ foot.name }}
                </option>
              </select>
            </CCol>
          </CRow>
        </CCol>
        <CCol col="12" sm="6" lg="4">
          <CRow class="py-2 py-mobile-0">
            <CCol sm="12">
              <label>{{ $t("label.division") }}</label>
            </CCol>
            <CCol sm="12">
              <select
                class="form-control form-group"
                v-model="searchData.division_code"
                @change="search"
              >
                <option value="0">
                  {{ $t("placeholder.label_employee_option_search") }}
                </option>
                <option
                  v-for="division in filterDivision"
                  :key="division.id"
                  :value="division.code"
                >
                  {{ division.name }}
                </option>
              </select>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow class="justify-content-center btn-search-mb">
        <CButton @click="search" class="btn-search-timesheet">{{
          $t("label.search")
        }}</CButton>
        <CButton class="btn-reset" @click="resetForm">{{
          $t("button.label_action_reset")
        }}</CButton>
      </CRow>
    </CCard>
    <div class="table-list">
      <CCard>
        <CCardBody>
          <CRow class="justify-content-end p-2 mb-mobile-2">
            <CButton color="warning ml-3" @click="exportData">Export</CButton>
          </CRow>
          <div class="option-table">
            <div class="form-group">
              <select
                class="form-control"
                v-model="searchData.itemsPerPage"
                @change="search"
              >
                <option
                  v-for="item in listItemsPerPage"
                  :value="item"
                  :key="item"
                >
                  {{ item }}
                </option>
              </select>
            </div>
            <template
              v-if="timeSheetSummary.data && timeSheetSummary.data.length > 0"
            >
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ $t("commons.label_text_to") }} {{ searchData.paginate.to }}
                {{ $t("commons.label_text_of") }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
            <template v-else>
              <div class="show-text-table">
                {{ $t("commons.label_text_show") }}
                {{ searchData.paginate.from }}
                {{ searchData.paginate.to }}
                {{ searchData.paginate.totalRecord }}
                {{ $t("commons.label_text_entries") }}
              </div>
            </template>
          </div>
          <div class="table-responsive">
            <table class="table table-mobile table-tablet">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ $t("label.employee_code") }}</th>
                  <th class="min-width-150">{{ $t("label.full_name") }}</th>
                  <th>Foot</th>
                  <th>{{ $t("label.division") }}</th>
                  <th>{{ $t("employee.contract_name") }}</th>
                  <th>{{ $t("employee.contract_start_date") }}</th>
                  <th>{{ $t("timeSheets.work_time_real_hour") }}</th>
                  <th>{{ $t("timeSheets.work_time_real_day") }}</th>
                  <th>{{ $t("timeSheets.work_time_pay_hour") }}</th>
                  <th>{{ $t("timeSheets.work_time_pay_day") }}</th>
                  <th class="min-width-200">{{ $t("timeSheets.note") }}</th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-if="
                    timeSheetSummary.data && timeSheetSummary.data.length > 0
                  "
                >
                  <tr
                    v-for="(timeSheet, index) in timeSheetSummary.data"
                    :key="timeSheet.id"
                    :class="timeSheet.day_off ? 'day-off' : 'null'"
                  >
                    <td>
                      {{
                        (timeSheetSummary.current_page - 1) *
                          timeSheetSummary.per_page +
                        index +
                        1
                      }}
                    </td>
                    <td>{{ timeSheet.employee_id }}</td>
                    <td>{{ timeSheet.employee_name }}</td>
                    <td>{{ timeSheet.foot ? timeSheet.foot : "-" }}</td>
                    <td>{{ timeSheet.division ? timeSheet.division : "-" }}</td>
                    <td>
                      {{
                        timeSheet.contract_code
                          ? $t(`employee.type_${timeSheet.contract_code}`)
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        timeSheet.contract_start_date
                          ? timeSheet.contract_start_date
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        timeSheet.work_time_real_hour
                          ? timeSheet.work_time_real_hour
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        timeSheet.work_time_real_day
                          ? timeSheet.work_time_real_day
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        timeSheet.work_time_pay_hour
                          ? timeSheet.work_time_pay_hour
                          : "-"
                      }}
                    </td>
                    <td>
                      {{
                        timeSheet.work_time_pay_day
                          ? timeSheet.work_time_pay_day
                          : "-"
                      }}
                    </td>
                    <td>
                      <div v-if="timeSheet.ot_150_hour">
                        - {{ $t("timeSheets.ot_150_hour") }}:
                        {{ timeSheet.ot_150_hour }}
                      </div>
                      <div v-if="timeSheet.ot_200_hour">
                        - {{ $t("timeSheets.ot_200_hour") }}:
                        {{ timeSheet.ot_200_hour }}
                      </div>
                      <div v-if="timeSheet.ot_150_day">
                        - {{ $t("timeSheets.ot_150_day") }}:
                        {{ timeSheet.ot_150_day }}
                      </div>
                      <div v-if="timeSheet.ot_200_day">
                        - {{ $t("timeSheets.ot_200_day") }}:
                        {{ timeSheet.ot_200_day }}
                      </div>
                      <div v-if="timeSheet.compensation_leave">
                        -
                        {{
                          $t("commons.label_status_sabbatical_leave_type_1")
                        }}: {{ timeSheet.compensation_leave }}
                      </div>
                      <div v-if="timeSheet.paid_leave">
                        -
                        {{
                          $t("commons.label_status_sabbatical_leave_type_2")
                        }}: {{ timeSheet.paid_leave }}
                      </div>
                      <div v-if="timeSheet.unpaid_leave">
                        -
                        {{
                          $t("commons.label_status_sabbatical_leave_type_3")
                        }}: {{ timeSheet.unpaid_leave }}
                      </div>
                      <div v-if="timeSheet.work_time_additional_day">
                        -
                        {{
                          $t(
                            "sabbatical-compensate.label_sabbatical_compensate"
                          )
                        }}: {{ timeSheet.work_time_additional_day }}
                      </div>
                      <div v-if="timeSheet.compensation_day">
                        -
                        {{ $t("commons.label_status_sabbatical_compesation") }} (Ngày):
                        {{ timeSheet.compensation_day }}
                      </div>
                      <div
                        v-if="
                          !timeSheet.ot_150_hour &&
                          !timeSheet.ot_200_hour &&
                          !timeSheet.ot_150_day &&
                          !timeSheet.ot_200_day &&
                          !timeSheet.paid_leave &&
                          !timeSheet.compensation_leave &&
                          !timeSheet.unpaid_leave &&
                          !timeSheet.work_time_additional_day &&
                          !timeSheet.sabbatical_leave
                        "
                      >
                        -
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="13" class="text-center">
                      {{ $t("table.label_data_not_found") }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </CCardBody>
        <CPagination
          v-if="timeSheetSummary.data && timeSheetSummary.data.length > 0"
          :activePage.sync="searchData.paginate.currentPage"
          :pages="searchData.paginate.totalPage"
          @update:activePage="fetchTimeSheetData"
          size="sm"
          align="center"
        />
      </CCard>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import XLSX from "xlsx";
import "sweetalert2/src/sweetalert2.scss";
import DatePickerFormFlex from "@/components/Common/DatePickerFormFlex";
import moment from "moment";

export default {
  name: "TimeSheetSummary",
  metaInfo() {
    return {
      title: this.$t("page_title.page_timesheet_summary_old"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    DatePickerFormFlex,
  },
  data() {
    return {
      searchData: {
        start_date: null,
        end_date: null,
        company_code: "0",
        foot_code: "0",
        division_code: "0",
        employee_info: "",
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
      export: true,
    };
  },
  created() {
    this.searchData.start_date = this.getDateSearch().firstDay;
    this.searchData.end_date = this.getDateSearch().lastDay;
    this.fetchTimeSheetData();
  },
  computed: {
    ...mapGetters({
      timeSheetSummary: "timeSheet/timeSheetSummary",
      timeSheetSummaryExport: "timeSheet/timeSheetSummaryExport",
      pagination: "timeSheet/pagination",
      companies: "commons/companies",
      foots: "commons/foots",
      divisions: "commons/divisions",
      listItemsPerPage: "commons/listItemsPerPage",
      countSubmittedEmployee: "timeSheet/countSubmittedEmployee",
      mustSubmit: "commons/mustSubmit",
    }),
    filterDivision() {
      if (this.searchData.foot_code === "0") return this.divisions;
      return this.divisions.filter(
        (division) => division.parent_code === this.searchData.foot_code
      );
    },

    btnDisplay() {
      return this.mustSubmit;
    },
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),

    startDate(data) {
      this.searchData.start_date = data;
    },

    endDate(data) {
      this.searchData.end_date = data;
    },

    resetForm() {
      this.searchData.start_date = this.getDateSearch().firstDay;
      this.searchData.end_date = this.getDateSearch().lastDay;
      this.searchData.company_code = "0";
      this.searchData.foot_code = "0";
      this.searchData.division_code = "0";
      this.searchData.employee_info = "";
    },

    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      let lastDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: Intl.DateTimeFormat("en-GB").format(lastDay),
      };
    },

    async fetchTimeSheetData() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/fetchTimeSheetSummary", {
          start_date: this.searchData.start_date,
          end_date: this.searchData.end_date,
          foot_code: this.searchData.foot_code,
          division_code: this.searchData.division_code,
          company_code: this.searchData.company_code,
          employee_info: this.searchData.employee_info,
          itemsPerPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage,
        })
        .then(() => {
          this.setLoading(false);
          this.searchData.paginate = this.pagination;
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    async exportData() {
      this.setLoading(true);
      await this.$store
        .dispatch("timeSheet/fetchTimeSheetSummaryExport", {
          start_date: this.searchData.start_date,
          end_date: this.searchData.end_date,
          foot_code: this.searchData.foot_code,
          division_code: this.searchData.division_code,
          company_code: this.searchData.company_code,
          employee_info: this.searchData.employee_info,
          export: this.export,
        })
        .then(() => {
          this.setLoading(false);
          this.$toast(
            this.$t("popup.label_popup_export_success"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
        })
        .catch(() => {
          this.setLoading(false);
        });
      let Heading = [
        [
          "Mã nhân viên",
          "Họ và tên",
          "Foot",
          "Division",
          "Loại HĐ",
          "Ngày ký HĐ",
          "Tổng công trong khung giờ  làm việc chuẩn (giờ)",
          "OT 150% (Giờ)",
          "OT 200% (Giờ)",
          "Tổng công trong khung giờ  làm việc chuẩn (ngày)",
          "OT 150% (Ngày)",
          "OT 200% (Ngày)",
          "Ngày nghỉ bù OT",
          "Nghỉ bù phép",
          "Nghỉ việc riêng hưởng lương",
          "Nghỉ không lương",
          "Bổ sung công (Ngày)",
          "Tổng công tính lương (Giờ)",
          "Tổng công tính lương (Ngày)",
        ],
      ];
      var ws = XLSX.utils.aoa_to_sheet(Heading);
      let dataExport = this.timeSheetSummaryExport.data;
      ws = XLSX.utils.sheet_add_json(ws, dataExport, {
        skipHeader: true,
        origin: "A2",
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Tổng hợp công số");
      XLSX.writeFile(
        wb,
        "Tổng hợp công số_" +
          Date.now() +
          "_" +
          this.searchData.start_date +
          "-" +
          this.searchData.end_date +
          ".xlsx"
      );
    },
    async search() {
      this.searchData.paginate.currentPage = 1;
      this.setLoading(true);
      try {
        await this.fetchTimeSheetData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },
  },
};
</script>

<style scoped>
.filter {
  margin: -2rem -2rem 0rem -2rem;
  padding: 2rem;
}
.table-list {
  margin-top: 1.5rem;
}
tr.day-off {
  background-color: #f0f8ff;
}
th,
td {
  vertical-align: middle !important;
}
.required,
.error-required {
  color: #dc1313;
  font-size: 13px;
}
.option-table {
  display: flex;
  justify-content: space-between;
}
.btn-search-timesheet {
  background-color: #b5dbf2;
  padding: 8px;
  width: 120px;
}
.btn:focus,
.btn.focus {
  box-shadow: none !important;
}
@media only screen and (max-device-width: 480px) {
  .mb-mobile-2 {
    margin-bottom: 0.5rem;
  }
  .btn-search-mb {
    margin-top: 15px;
  }
}
@media only screen and (max-device-width: 767px) {
  .py-mobile-0 {
    padding: 0 !important;
  }
  .btn-search-mb {
    margin-top: 15px;
  }
  .show-text-table {
    margin-left: 20px;
  }
  .table-mobile {
    width: 1600px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1600px;
    overflow-x: scroll;
  }
}
</style>
